import { render } from "./Regis.vue?vue&type=template&id=64a89ff8"
import script from "./Regis.vue?vue&type=script&lang=js"
export * from "./Regis.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\vue\\family-notes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__